import useContent from "@@hooks/useContent";
import useDamageRecognition from "@@pages/item-details/hooks/useDamageRecognitionContext";
import { TableBody, TableCell, TableRow, Typography } from "@lux/ds";
import {
  ExteriorDamageLocationKeys,
  GenericDamageKeys,
  HardwareDamageLocationKeys,
  InteriorDamageLocationKeys,
} from "types/damages";
import {
  ExteriorInteriorLocationDamage,
  GenericDamage,
  HardwareLocationDamage,
} from "./content";
import { StyledTable } from "./DamageTable.styles";

interface IDamageTableHeaderItem {
  key: string;
  label: string;
}

interface IDamageTableProps {
  damageKeys:
    | ExteriorDamageLocationKeys[]
    | HardwareDamageLocationKeys[]
    | InteriorDamageLocationKeys[]
    | GenericDamageKeys[];
  headers: IDamageTableHeaderItem[];
  showGenericDamages: boolean;
  tab: string;
}

const DamageTable: React.FC<IDamageTableProps> = ({
  damageKeys,
  headers,
  showGenericDamages,
  tab,
}) => {
  const {
    content: { itemReview: content },
  } = useContent();
  const { damageCounts } = useDamageRecognition();

  return (
    <StyledTable striped headers={headers}>
      <TableBody>
        {damageKeys.map((damageKey) => {
          return (
            <TableRow key={damageKey}>
              <TableCell component='th' scope='row' width={174}>
                <Typography variant='bodyTextSmall'>
                  {content.damageLocation[damageKey]}
                </Typography>
                <Typography variant='caption' sx={{ color: "#6A626A" }}>
                  {content.damageCategory.damages}:{" "}
                  {damageCounts[damageKey] ?? 0}
                </Typography>
              </TableCell>

              {tab === "exterior" && (
                <ExteriorInteriorLocationDamage
                  name={damageKey as ExteriorDamageLocationKeys}
                />
              )}
              {tab === "interior" && (
                <ExteriorInteriorLocationDamage
                  name={damageKey as InteriorDamageLocationKeys}
                />
              )}
              {tab === "hardware" && (
                <HardwareLocationDamage
                  name={damageKey as HardwareDamageLocationKeys}
                />
              )}
            </TableRow>
          );
        })}
        {showGenericDamages ? <GenericDamage /> : null}
      </TableBody>
    </StyledTable>
  );
};

export default DamageTable;
